// Ist das Browserfenster gerade sichtbar (nicht verdeckt, nicht im
// Hintergrund-Tab, Telefon nicht gesperrt)? Reaktiv, mit EINEM Satz
// Listener für alle Leser. Zusammen mit seiteVorn() in seiteSichtbar()
// (shell/page-route.ts): was der Server oder das Netz bezahlt -- ein
// Präsenz-Abo, das einen Agenten hochtaktet, ein Abruf alle paar Sekunden
// --, läuft nur, solange es jemand sieht.
//
// Nicht nur visibilitychange (Tim 23.10.2026: „Die Werte auf der
// Serverseite aktualisieren sich oft erst nach page reload wieder
// regelmäßig. Auch wenn Homelab lange im Browser geöffnet ist und der Mac
// mal schlafen war"): beim Einschlafen kommt „hidden" an, das „visible"
// beim Aufwachen geht in Safari bisweilen verloren -- die Seite galt dann
// bis zum Neuladen als verdeckt und abonnierte keine Live-Werte mehr.
// Darum liest jeder Hinweis, dass jemand da ist (Fokus, Rückkehr der
// Seite, Bedienung), document.hidden neu, und alle 15 s ein Abgleich als
// letztes Netz. Gelesen wird nur ein Feld; geschrieben nur bei Änderung.

let sichtbar = $state(typeof document === "undefined" ? true : !document.hidden);
let beobachtet = false;

const ABGLEICH_MS = 15_000;

function abgleich(): void {
  const jetzt = !document.hidden;
  if (jetzt !== sichtbar) sichtbar = jetzt;
}

export function fensterSichtbar(): boolean {
  if (!beobachtet && typeof document !== "undefined") {
    beobachtet = true;
    document.addEventListener("visibilitychange", abgleich);
    for (const ereignis of ["focus", "pageshow", "pagehide"]) {
      window.addEventListener(ereignis, abgleich);
    }
    // Page Lifecycle (Chromium): nach dem Einfrieren beim Schlafen.
    document.addEventListener("resume", abgleich);
    // Bedienung beweist Sichtbarkeit -- passiv, nur ein Feld lesen.
    for (const ereignis of ["pointerdown", "keydown", "wheel"]) {
      window.addEventListener(ereignis, abgleich, { passive: true, capture: true });
    }
    setInterval(abgleich, ABGLEICH_MS);
  }
  return sichtbar;
}
